import { appendAlertList, errorAlertList, initAlertListRequest, setAlertList } from "./action";
import { serverCall } from "utils/serverCall";
import apiEndpoints from "utils/apiList";

export const fetchAlertList = ({ page = 1, limit = 20 } = {}) => {
  return async (dispatch) => {
    dispatch(initAlertListRequest());
    try {
      const result = await serverCall(`${apiEndpoints.ALERT_NOTIFICATION}?page=${page}&limit=${limit}`, 'GET', dispatch);
      if (result.success && result.data) {
        const payload = {
          data: result.data.data,
          page: result.data.page,
          total: result.data.total,
          totalPage: result.data.totalPage,
          pageSize: result.data.pageSize,
        };
        dispatch(page === 1 ? setAlertList(payload) : appendAlertList(payload));
      } else {
        dispatch(errorAlertList(result.message));
      }
    } catch (error) {
      dispatch(errorAlertList(error.message));
    }
  };
};

